export const pillars = ['Leads', 'Listings', 'Conversion', 'Negotiation', 'Follow-Up', 'Authority'];

export const volumes = [
  {
    n: 1,
    label: 'Leads',
    title: 'AI Lead Generation Engine',
    tagline: 'Build a stronger prospecting workflow with AI.',
    desc: 'Generate lead magnets, prospecting ideas, local-market content, referral opportunities, open-house lead strategies, FSBO outreach, expired-listing approaches and more.',
    count: 16,
  },
  {
    n: 2,
    label: 'Listings',
    title: 'The Listing Machine',
    tagline: 'Turn property information into professional marketing assets.',
    desc: 'Create listing descriptions, headlines, social campaigns, photo storytelling, open-house promotions, listing emails, buyer-persona positioning and complete property marketing plans.',
    count: 17,
  },
  {
    n: 3,
    label: 'Conversion',
    title: 'The Lead Conversion System',
    tagline: 'Know what to say when a new lead enters your pipeline.',
    desc: 'Create instant lead responses, buyer and seller qualification flows, lead-intent analysis, appointment scripts, showing follow-ups, objection responses and conversation-rescue frameworks.',
    count: 17,
  },
  {
    n: 4,
    label: 'Negotiation',
    title: 'The Objection & Negotiation Playbook',
    tagline: 'Prepare for the conversations that can become difficult.',
    desc: 'Work through commission objections, pricing objections, low offers, competing-agent situations, difficult clients, negotiation scenarios and deals that are beginning to stall.',
    count: 17,
  },
  {
    n: 5,
    label: 'Follow-Up',
    title: 'The Follow-Up & CRM Engine',
    tagline: 'Stop letting promising conversations disappear.',
    desc: 'Build structured follow-up sequences for new leads, buyers, sellers, ghosted prospects, old leads, open-house visitors, website leads, referrals and past clients.',
    count: 17,
  },
  {
    n: 6,
    label: 'Authority',
    title: 'The REALTOR® Authority Engine',
    tagline: 'Use AI to build your professional visibility.',
    desc: 'Create your personal positioning, REALTOR® bio, local authority strategy, social content plans, market updates, educational content, video scripts, buyer education, seller education and referral campaigns.',
    count: 16,
  },
];

export const promptQualities = [
  'Copy-and-paste ready',
  'Easy to customize',
  'Organized by real estate workflow',
  'Built around specific professional scenarios',
  'Compatible with leading AI assistants',
  'Designed to produce practical, structured outputs',
];

export type Bonus = {
  n: number;
  title: string;
  subtitle: string;
  body: string[];
  tags?: string[];
  closing?: string;
  value: string;
  cover: string;
};

export const bonuses: Bonus[] = [
  {
    n: 1,
    title: 'The Realtor AI Quick-Start Vault™',
    subtitle: 'Your 30-Minute Setup Guide for Turning AI Into Your Daily Real Estate Assistant',
    body: [
      'Learn how to configure your AI workflow, provide better context, create reusable instructions, improve generic outputs and build a repeatable daily AI routine.',
    ],
    closing: 'A faster way to go from “I bought the system” to actually using it.',
    value: '$29',
    cover: 'https://cdn.magicpatterns.com/uploads/surJaDFP9V77fZaDhYdun2/BONO_1.webp',
  },
  {
    n: 2,
    title: 'The 30-Day Realtor Content Calendar™',
    subtitle: '30 Days of Ready-to-Create Content Designed to Start Real Conversations',
    body: [
      'A practical 30-day content roadmap covering buyers, sellers, local expertise, personal branding and real estate education.',
    ],
    tags: ['Daily content direction', 'Content angles', 'Hooks', 'Format ideas', 'CTA ideas'],
    value: '$27',
    cover: 'https://cdn.magicpatterns.com/uploads/1kVn4FZc9NDJa7M6txdxFs/BONO_1_(1).webp',
  },
  {
    n: 3,
    title: 'The Realtor Follow-Up Message Vault™',
    subtitle: '100 Ready-to-Adapt Messages for Leads, Clients & Past Contacts',
    body: [
      'Sometimes you don’t need another prompt. You need a message you can adapt and send.',
      'Get 100 starting-point messages covering new leads, buyers, sellers, ghosted leads, old contacts, open houses, showings, referrals, appointments and past clients.',
    ],
    value: '$37',
    cover: 'https://cdn.magicpatterns.com/uploads/fwF2BjLZJN1f9AWXSb6F86/BONO_1_(2).webp',
  },
  {
    n: 4,
    title: 'The Open House Profit Kit™',
    subtitle: 'The Complete AI-Powered Open House Lead Capture & Follow-Up System',
    body: [
      'A practical before / during / after framework for turning an open house into a structured lead-capture and follow-up process.',
    ],
    tags: ['Promotion', 'Visitor capture', 'Qualification', 'Follow-up', 'Lead organization', 'Post-event nurture'],
    value: '$29',
    cover: 'https://cdn.magicpatterns.com/uploads/qkkkeP5z3dnXhioWkg5SLp/BONO_1_(3).webp',
  },
  {
    n: 5,
    title: 'The Realtor AI Command Center™',
    subtitle: 'The One-Page Decision System That Tells You Which AI Tool to Use Next',
    body: [
      'No more searching through 100 prompts trying to remember where to start. Simply identify what you’re trying to accomplish:',
    ],
    tags: ['Need more leads?', 'New lead?', 'Lead stopped responding?', 'Need listing copy?', 'Preparing for an objection?', 'Need content?', 'Running an open house?'],
    closing: 'The Command Center points you toward the relevant workflow.',
    value: '$29',
    cover: 'https://cdn.magicpatterns.com/uploads/hZmQuPGZgjhoDt4M6pPZ3k/BONO_1_(4).webp',
  },
];
